module.exports = "/_next/static/images/businessPlanning-69ba899a1996e4dd64d03c756fa7ad7c.webp";